import XTbl,{Xtc} from '../../../../components/x-table';
const tbl = new XTbl('', 'session');

tbl.add(new Xtc('names', 'Name').renderSlot('names'))
tbl.add(new Xtc('ip', 'IP Address').renderSlot('ip'))
tbl.add(new Xtc('Access', 'Last Access Date'))
tbl.add(new Xtc('lastActive', 'Last Active').renderSlot('last-active'))
tbl.add(new Xtc('active', 'Active For').renderSlot('active'))

export default tbl;

